import { cn } from '../../lib/utils';
import { Skeleton, SKELETON_REVEAL_CLASS, SkeletonGroup } from '../portal';

/** Mirrors the 72px `AppSwitcher` trigger (40px icon + name) while apps load. */
export function SidebarSwitcherSkeleton() {
  return (
    <SkeletonGroup
      label="Loading apps"
      className="flex h-[72px] w-full shrink-0 items-center gap-3 rounded-lg bg-black px-2"
    >
      <Skeleton className="size-10" rounded="lg" />
      <span className="flex h-5 flex-1 items-center">
        <Skeleton className="h-3.5 w-28" />
      </span>
    </SkeletonGroup>
  );
}

const NAV_ROW_WIDTHS = ['w-20', 'w-16', 'w-32', 'w-24'];

/**
 * Mirrors the "Navigation" `SectionLabel` (44px incl. padding) plus four 36px
 * `NavRow`s (16px icon, 14px label) so nothing shifts when the nav lands.
 */
export function SidebarNavSkeleton() {
  return (
    <span
      aria-hidden="true"
      className={cn('flex flex-col gap-1', SKELETON_REVEAL_CLASS)}
    >
      <span className="flex h-11 items-center px-2 pb-2 pt-4">
        <Skeleton className="h-3 w-20" />
      </span>
      {NAV_ROW_WIDTHS.map((width) => (
        <span key={width} className="flex h-9 items-center gap-2.5 pl-4 pr-2">
          <Skeleton className="size-4" />
          <Skeleton className={cn('h-3.5', width)} />
        </span>
      ))}
    </span>
  );
}
